export const createField = ({
  key,
  placeholder,
  value,
  required
}) => {
  if (!key) {
    throw Error('Provide a Key to the field');
  }
  if (!required) {
    required = false;
  }
  if (!placeholder) {
    placeholder = key;
  }

  return {
    key,
    placeholder,
    value,
    required,
  };
}

export const createFields = (fields = [createField()]) => fields.map(createField);
